import React, { useContext } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import goto from '@/common/goto';
import env from '@/env';
import Microapp from '@/components/micro-app';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { getQuery } from '@/common/utils';
import './index.less';

/*****************
 * 品店策略 - 商品策略 - 新建 *
 *****************/
function customCrumb() {
  return (
    <div className="custom-crumb-fa">
      <div className="crumb-font">新建商品策略</div>
    </div>
  );
}

export const StrategyNewExtraHeaderProps = {
  backIcon: <ArrowLeftOutlined />,
  onBack: () => {
    const activityId = getQuery('activityId');
    goto.dailyGoodsStrategyList(activityId).push();
  },
  renderCrumbs: customCrumb,
  background:
    '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
  btns: [],
};

const DailyGoodsStrategyNew = withRouter((props) => {
  const { roomId, dailyData, activityId: activityIdByText } = useContext(ContextProviderMenus);
  const activityIdByQuery = getQuery('activityId');
  const activityId = activityIdByText || activityIdByQuery;

  /* 子应用新建完成回调通知 */
  function onCreateSuccess({ aid, jid, createdBy }) {
    goto
      .dailyGoodsStrategyDetail({
        activityId,
        name: '',
        roomId,
        jid,
        createdBy,
        formCreate: true,
        aid,
      })
      .replace();
  }

  return (
    <div className="daily-goods-strategy-new-wrapper">
      <div className="new-body-fa">
        <Microapp
          destory={true}
          data={{
            onCreateSuccess: onCreateSuccess,
          }}
          name="GoodsStrategyNew"
          /* http://wareops.man.jd.com/#/flow-field/create-job?promotionActivityId=27741 */
          url={`${env.WAREOPS_DOMAIN}/#/flow-field/create-job`}
        />
      </div>
    </div>
  );
});

export default DailyGoodsStrategyNew;
